export const formatDecimalPlaces = (value: number) => {
  return Math.round(value)?.toLocaleString('en-US')?.replaceAll(',', '.')
}

export const formatDecimalPlacesCurrency = (value: number) => {
  return Math.fround(value).toFixed(2).replaceAll(',', '.')
}
